import React from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";

const SingleEditItem = ({ label, index, id, onEdit, onDelete }) => {
    let isOdd = true;

    if (index % 2 == 0) {
        isOdd = false;
    }

    const onEditHandler = () => {
        onEdit(id);
    };

    const onDeleteHandler = () => {
        onDelete(id);
    };

    return (
        <div
            className={
                isOdd == true
                    ? "flex flex-1 justify-between rounded-sm  py-1 pl-2"
                    : "flex flex-1 justify-between rounded-sm bg-main-600 py-1 pl-2"
            }
            key={id}
            data-id={id}
        >
            {label}
            <div className='flex flex-row'>
                <MdModeEdit
                    onClick={onEditHandler}
                    className='d-inline mr-1 cursor-pointer text-xl'
                />

                <MdDelete onClick={onDeleteHandler} className='d-inline cursor-pointer text-xl' />
            </div>
        </div>
    );
};

export default SingleEditItem;
